module.exports = __webpack_public_path__ + "img/aspen-fall-icon.72f9de42.png";